<template>
  <v-app-bar
    :clipped-left="$vuetify.breakpoint.lgAndUp"
    dark
    class="background-gradient app-bar"
    app
  >
    <v-app-bar-nav-icon
      class="hamburger-menu"
      @click="hamburgerClicked"
    />

    <!--    desktop logo-->
    <v-toolbar-title
      v-if="!isMobile"
      class="mr-12 d-inline-flex align-center"
      style="max-height: 100%"
    >
      <router-link
        v-if="$vuetify.breakpoint.name !== 'xs'"
        :to="{ path: userHomePagePath }"
        class="d-inline-flex align-center"
      >
        <img
          :src="logoSmall"
          alt="Logo"
          class="logo"
        >
      </router-link>
    </v-toolbar-title>

    <!--    centered logo on mobile-->
    <v-spacer />
    <image-field
      v-if="isMobile"
      src="/img/images/ecomobile-login-mobile-logo.svg"
      contain
      max-width="122"
      height="24"
      @onClick="goHome"
    />
    <v-spacer />

    <!--    company scope btn, visible only on desktop-->
    <CompanyScope
      v-if="companyScope && !isMobile"
      :company-scope="companyScope"
      class="mr-2"
    />

    <!--    user menu selection-->
    <AvatarMenu
      v-slot="{ listeners, attributes, open: isOpen }"
      :company-scope="companyScope"
      :user-menu="userMenu"
    >
      <div
        v-bind="attributes"
        v-on="listeners"
      >
        <template
          v-if="isMobile"
        >
          <image-field
            :src="publicImage(user.avatar_url)"
            height="24"
            max-width="24"
            style="border-radius: 50%;"
            contain
          />
        </template>
        <template
          v-else
        >
          <universal-button
            type="base"
            :src="publicImage(user.avatar_url)"
            :image-config="{
              height: 32,
              maxWidth: 32
            }"
            label=""
            class="user-menu-btn"
            color="#111827"
          >
            <template
              #label
            >
              <span
                class="d-inline-block mr-1 ml-2"
              >
                <span
                  class="hidden-sm-and-down text-capitalize"
                >
                  {{ user.first_name }} {{ user.last_name }}
                </span>
              </span>
              <v-icon
                class="hidden-sm-and-down"
              >
                {{ isOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
              </v-icon>
            </template>
          </universal-button>
        </template>
      </div>
    </AvatarMenu>
  </v-app-bar>
</template>
<script>
import AvatarMenu from '@/modules/base-module/avatar-menu/components/AvatarMenu'
import CompanyScope from '@/modules/base-module/company-scope/components/CompanyScope'
import { createNamespacedHelpers } from 'vuex'
import { defaultAvatarUrl } from '@/global/common/imagePaths'
import UniversalButton from '@/global/components/buttons/UniversalButton.vue'
import ImageField from '@/global/components/fields/ImageField.vue'
import helperMixin from '@/global/mixins/helperMixin'

const { mapGetters, mapActions } = createNamespacedHelpers('base/config')

export default {
  name: 'TheAppBar',

  components: {
    ImageField,
    UniversalButton,
    AvatarMenu,
    CompanyScope
  },

  mixins: [
    helperMixin
  ],

  props: {
    refetch: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters({
      user: 'user',
      userMenu: 'userMenu',
      logoSmall: 'logoSmall',
      companyScope: 'companyScope'
    }),

    userHomePagePath () {
      // When home page is equal to `/`, this will result in two slashes `//`. The regex inside
      // `replace` method converts multiple slashes into one to avoid navigation errors.
      return `/${this.user.home_page}`.replace(/\/\/+/g, '/')
    }
  },

  watch: {
    refetch (refetch) {
      if (refetch) {
        this.fetch()
      }
    }
  },

  methods: {
    ...mapActions(['fetch']),

    hamburgerClicked () {
      this.$emit('hamburger-toggle')
      if (!this.$store.state.isMenuNavOpen) {
        this.$store.commit('toggleMenuNav', true)
      }
      else {
        this.$store.commit('toggleMenuNav', false)
      }
    },

    publicImage (imageUrl) {
      return imageUrl ?? defaultAvatarUrl
    },

    goHome () {
      if (this.$route.path !== this.userHomePagePath) {
        this.$router.replace({ path: this.userHomePagePath })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.logo {
  height: 40px;
  width: auto;
  object-fit: contain;
}

.app-bar {
  background-color: #1F2937 !important;
  box-shadow: unset !important;
}
@media (max-width: 960px) {
  .logo {
    height: 35px;
  }
}
.user-menu-btn {
  border: 1px solid #374151 !important;
  background-color: #1F2937 !important;
  color: #FFFFFF;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 20px !important;
}

::v-deep {
  .user-menu-btn {
    padding: 4px 12px 4px 4px !important;
  }
  .user-menu-btn > .v-btn__content {
    width: 100%;
    height: 100%;
  }
}
</style>
